import Tooltip from "@material-ui/core/Tooltip";
import React, { Component } from "react";
import ControlPointDuplicateIcon from "@mui/icons-material/ControlPointDuplicate";
export class CreateSimilerButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      domainObject: props.onClick,
      onClick: props.onClick,
      caption: props.caption,
    };
  }

  onClick() {
    if (this.state.onClick) {
      this.state.onClick();
    }
  }
  render() {
    return (
      <span
        className="createSimilar"
        onClick={this.onClick.bind(this)}
        style={{
          cursor: "pointer",
          fontSize: "x-larger",
          float: "right",
          marginRight: "3px",
          // paddingTop: "5px",
          display: "flex",
        }}
      >
        <Tooltip title="Duplicate  Msg" classes={{ popper: "custom-tooltip" }} arrow>
          <ControlPointDuplicateIcon
            style={{
              borderRadius: "25%",
              color: "#6A7B8E",
              fontSize: "x-large",
              width: "30px",
              minHeight: "30px",
              padding: "3px",
            }}
          />
        </Tooltip>
      </span>
    );
  }
}
export default CreateSimilerButton;
